<template>
  <b-navbar
    class="header"
    type="dark"
    variant="darkBlue"
  >
    <b-navbar-brand
      to="/app/all-modules"
      class="p-0"
    >
      <b-img
        src="/assets/img/Atlas by HM_horizontal_white.png"
        class="navbar-brand-img"
      />
    </b-navbar-brand>

    <!--    <SidebarToggle/>-->
    <!--    <div class="clearfix-xxs"></div>-->
    <div class="navbar-items pull-right">
      <b-navbar-nav class="user-actions">
        <!--    Avatar -->
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <b-img
              rounded="circle"
              class="user-avatar mr-2"
              :src="avatar"
              alt="..."
            />
            {{ user.name }}
            <b class="caret" />
          </template>
          <b-dropdown-item :to="{name: 'profile'}">
            Profile
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="onLogoutClick()"
          >
            Sign Out
          </b-dropdown-item>
          <b-dropdown-item disabled>
            Version  {{ version }} <br><small>{{ versionDate | toDatetime }}</small>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
    <!--    <div class="clearfix-xxs"></div>-->
    <div class="navbar-items-2 ml-auto">
      <!-- Right aligned nav items -->
      <b-navbar-nav>
        <b-nav-item @click="toggleFullscreen">
          <font-awesome-icon
            class="navbar-icon"
            icon="compress"
          />
        </b-nav-item>
      </b-navbar-nav>
    </div>
  </b-navbar>
</template>

<script>
import SidebarToggle from './components/SidebarToggle';
import {createNamespacedHelpers} from 'vuex';
import auth from '../../services/auth.service';
import {axiosClient} from '../../../core/services/http.service';

const {mapState} = createNamespacedHelpers('user');
export default {
  name: 'Navbar',
  components: {
    SidebarToggle,
  },
  data() {
    return {
      isOnFullScreen: false,
      version: null,
      versionDate: null,
    };
  },
  computed: {
    ...mapState(['user']),
    avatar() {
      return this.user.avatar || '/img/avatar.svg';
    },
  },
  methods: {
    onLogoutClick() {
      auth.logout();
    },
    toggleFullscreen(){
      if (this.isOnFullScreen){
        this.closeFullscreen();
        this.isOnFullScreen = false;
      } else {
        this.isOnFullScreen = true;
        this.openFullscreen();
      }
    },
    /* View in fullscreen */
    openFullscreen() {
      const elem = document.querySelector('body');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    /* Close fullscreen */
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    },
  },
  async mounted() {
    const {success, body} = await axiosClient.get('/api/version');
    if (success) {
      this.version = `${body.version}`;
      this.versionDate = `${body.updateDate}`;
    }
  },
};
</script>

<style src="./Navbar.scss" lang="scss">

</style>
